module.exports = __webpack_public_path__ + "img/V5C.cfdeecd2.png";